export default "__VITE_ASSET__iiONi9_w__"